import React from "react";
import { Link } from "react-router-dom";
import { t } from "../lib/i18n";

export default function NotFound() {
  return (
    <section
      data-testid="notfound-page"
      className="mx-auto flex max-w-3xl flex-col items-start px-5 pt-32 pb-24 sm:px-6"
    >
      <p className="mb-6 text-xs uppercase tracking-[0.32em] text-[#C8A24B]">
        {t("notfound.eyebrow")}
      </p>
      <h1 className="font-display text-4xl text-[#1A1A1A] sm:text-5xl">
        {t("notfound.title")}
      </h1>
      <p className="mt-6 max-w-xl text-base text-[#1A1A1A]/70">
        {t("notfound.subtitle")}
      </p>
      <Link
        data-testid="notfound-home-link"
        to="/"
        className="mt-10 inline-flex items-center rounded-full bg-[#C8A24B] px-7 py-3 text-xs uppercase tracking-[0.24em] text-[#1A1A1A] transition hover:bg-[#dbb359]"
      >
        {t("notfound.cta")}
      </Link>
    </section>
  );
}
